import { queryOptions } from "@tanstack/react-query";

import type { OrgService, OrgUserRecord } from "@/shared/domain/orgs";

/** Query key for an org's member list. */
export function orgUsersQueryKey(orgId: string | undefined) {
  return ["orgUsers", orgId] as const;
}

/**
 * Shared TanStack query options for one org's member list (user_id + display
 * name + roles) — the single definition point for the ``orgUsers`` cache key
 * and its freshness window, so any future observer inherits both instead of
 * re-declaring them.
 */
export function orgUsersQueryOptions(
  orgService: OrgService,
  orgId: string | undefined,
) {
  return queryOptions<OrgUserRecord[], Error>({
    queryKey: orgUsersQueryKey(orgId),
    queryFn: ({ signal }) => {
      if (orgId === undefined) {
        return Promise.reject(new Error("Invalid orgId"));
      }
      return orgService.getOrgUsers(orgId, { abortSignal: signal });
    },
    enabled: orgId !== undefined,
    // 30 seconds, the feature-flags member picker's original window: an admin
    // editing membership in one tab expects the picker to reflect it promptly.
    staleTime: 30_000,
  });
}
